/**
 * As duas abas da Calculadora Petrella: "Ajuda de Custo" e "Diaristas".
 *
 * Papel: reproduz a fileira de l. 962–964 e o `mudarAbaCalculadoraPetrella`
 * (l. 4818–4827): `gap:4px`, 16 px abaixo, borda inferior bege; cada aba sem
 * borda nem fundo, `8px 14px`, 13 px 600 na fonte que o navegador dá a todo
 * botão sem `font-family`; a ativa em `--foreground` com o sublinhado de 2 px,
 * a outra em `texto-fraco` com o sublinhado transparente.
 *
 * Como usar: a aba ativa é de quem monta, que troca o botão do rodapé junto.
 */
import { cn } from '@/shared/lib/utils';

/** Uma aba: a chave que quem monta guarda e o texto. */
export interface AbaDaCalculadora<Chave extends string> {
  chave: Chave;
  rotulo: string;
}

interface AbasDaCalculadoraProps<Chave extends string> {
  abas: readonly AbaDaCalculadora<Chave>[];
  ativa: Chave;
  onTrocar: (chave: Chave) => void;
}

/**
 * A fileira de abas.
 *
 * @param abas - As abas, na ordem.
 * @param ativa - A chave da aba à vista.
 * @param onTrocar - Chamado com a chave da aba clicada.
 * @returns A `tablist`.
 */
export function AbasDaCalculadora<Chave extends string>({
  abas,
  ativa,
  onTrocar,
}: AbasDaCalculadoraProps<Chave>) {
  return (
    <div role="tablist" className="mb-4 flex gap-1 border-b border-emb-borda">
      {abas.map((aba) => (
        <button
          key={aba.chave}
          type="button"
          role="tab"
          aria-selected={aba.chave === ativa}
          onClick={() => onTrocar(aba.chave)}
          className={cn(
            'cursor-pointer border-0 border-b-2 bg-transparent px-3.5 py-2 [font-family:revert] text-[13px] font-semibold',
            aba.chave === ativa
              ? 'border-b-foreground text-foreground'
              : 'border-b-transparent text-texto-fraco',
          )}
        >
          {aba.rotulo}
        </button>
      ))}
    </div>
  );
}
